import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    key,
    value,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.config.saveUserValue, { key, value }, options);
    if (error) return { error, status };
    return { ...content };
};
